module.exports = __webpack_public_path__ + "img/E7hVfArVUAI0idJ.d2de3f2b.jpg";